module.exports = __webpack_public_path__ + "pin_lightgreen.30230d.png";